import { useIntl } from "react-intl";

import { Select, SelectProps, Tag } from "antd";

import { useDepartments } from "@app/services/hook/useDepartments.tsx";
import { colorByDepartmentId } from "@app/services/utils/userUtils.ts";

interface CmtDepartmentFilterProps {
  defaultValue: string[];
  onQueryChange: (value: string[]) => void;
}

type TagRender = SelectProps["tagRender"];

const tagRender: TagRender = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { label, value, closable, onClose } = props;
  const val = typeof value === "string" ? value : "";

  const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      color={colorByDepartmentId[val] || "gray"}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ marginInlineEnd: 4 }}
    >
      {label}
    </Tag>
  );
};

export function CmtDepartmentFilter({
  defaultValue,
  onQueryChange,
}: Readonly<CmtDepartmentFilterProps>) {
  const intl = useIntl();
  const { departments } = useDepartments();

  const placeholderText = intl.formatMessage({
    id: "table.department_filter",
    defaultMessage: "All departments",
  });

  const options = departments.map((department) => ({
    label: department.name,
    value: department.id,
  }));

  return (
    <Select
      mode="multiple"
      value={defaultValue}
      tagRender={tagRender}
      style={{ flex: "1 1 220px", maxWidth: 360 }}
      maxTagCount="responsive"
      allowClear
      optionFilterProp="label"
      options={options}
      onChange={onQueryChange}
      placeholder={placeholderText}
    />
  );
}
